import { WFSCollector } from "./WFSCollector";
import { wfsEndpoints } from "./WFSCollectorEndpoints";

export class WFSUtilsCollector {

   static async bfeUnderPoint([lon, lat]: [number, number]) {
      let result = await WFSCollector.getFeaturePoint("Matriklen2", "Jordstykke_Gaeldende", [lon, lat]);
      return {
         sfeNr: result.features[0]?.properties?.samletFastEjendomLokalId,
         ejerl: result.features[0]?.properties?.ejerlavskode,
         matnr: result.features[0]?.properties?.matrikelnummer
      };
   }

   static async PlanData(geom: unknown, planType: keyof (typeof wfsEndpoints["Plandata.dk"]["featureTypes"])): Promise<GeoJSON.FeatureCollection> {
      let result = await WFSCollector.getFeatureIntersect("Plandata.dk", planType, geom as any).catch(err => {
         console.error("Error fetching plan data:", err);
      })
      console.log("Received plan data result:", result);
      return result;
   }
}